import React from "react";
import ReactHtmlParser from "react-html-parser";
import styled from "styled-components";
import Link from "@airasia/phoenix-components/components/Link";
import Icon from "@airasia/phoenix-components/components/Icon";


export default function merchant(props) {
    const cardData = props.data;
    const renderCard = (card, index) => {
        return (
            <Link 
            accessible
            color="primary"
            hoverUnderlined
            href={card.url}
            size="normal"
            stopPropagation
            target="tab"
            theme="AIRASIA_CLASSIC"
            type="normal"
            customProperties={{
                'aria-label': 'this is an a11y custom label',
                id: 'Link'
              }}
              >
            {ReactHtmlParser(card.subtitle)}
            <Icon
              accessible
              color="primary"
              fontsize="normal"
              icon="ChevronRightIcon"
              theme="AIRASIA_CLASSIC"
            /> 
          </Link>
        );
    }
    return (
        cardData.map(renderCard)
    );
}
